import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Instagram, Facebook, Globe, Twitter, ArrowLeft } from "lucide-react";

export default function AuthorDetail() {
  const { slug } = useParams();
  const [author, setAuthor] = useState(null);
  const [notFound, setNotFound] = useState(false);
  useEffect(() => {
    api.get(`/authors/by-slug/${slug}`).then((r) => setAuthor(r.data)).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) return (
    <div className="max-w-3xl mx-auto px-6 py-32 text-center">
      <h1 className="font-serif text-4xl mb-4">Autor não encontrado</h1>
      <Link to="/autores" className="btn-outline-gold text-sm border-[color:var(--marupiara-gold-dark)] text-[color:var(--marupiara-gold-dark)]">Ver autores</Link>
    </div>
  );
  if (!author) return <div className="py-32 text-center">Carregando…</div>;

  return (
    <div className="bg-[color:var(--marupiara-ivory)]">
      <section className="py-16 bg-[color:var(--marupiara-obsidian)] text-white">
        <div className="max-w-[1200px] mx-auto px-6 lg:px-10">
          <Link to="/autores" className="inline-flex items-center gap-2 text-sm text-[color:var(--marupiara-gold)] mb-8"><ArrowLeft size={14} /> Todos os autores</Link>
          <div className="grid md:grid-cols-3 gap-12 items-start">
            <div>
              <div className="aspect-[4/5] overflow-hidden bg-neutral-800">
                <img src={author.photo_url} alt={author.name} className="w-full h-full object-cover" />
              </div>
            </div>
            <div className="md:col-span-2">
              <div className="overline text-[color:var(--marupiara-gold)] mb-3">Autor</div>
              <h1 className="font-serif text-5xl sm:text-6xl leading-tight mb-6">{author.name}</h1>
              <p className="text-white/80 leading-relaxed text-lg mb-8">{author.biography}</p>
              <div className="flex gap-4">
                {author.instagram && <a href={author.instagram} target="_blank" rel="noreferrer" className="text-[color:var(--marupiara-gold)] hover:text-[color:var(--marupiara-gold-light)]"><Instagram size={22} /></a>}
                {author.facebook && <a href={author.facebook} target="_blank" rel="noreferrer" className="text-[color:var(--marupiara-gold)] hover:text-[color:var(--marupiara-gold-light)]"><Facebook size={22} /></a>}
                {author.twitter && <a href={author.twitter} target="_blank" rel="noreferrer" className="text-[color:var(--marupiara-gold)] hover:text-[color:var(--marupiara-gold-light)]"><Twitter size={22} /></a>}
                {author.website && <a href={author.website} target="_blank" rel="noreferrer" className="text-[color:var(--marupiara-gold)] hover:text-[color:var(--marupiara-gold-light)]"><Globe size={22} /></a>}
              </div>
            </div>
          </div>
        </div>
      </section>
      {author.books?.length > 0 && (
        <section className="py-16">
          <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
            <h2 className="font-serif text-4xl text-[color:var(--marupiara-obsidian)] mb-8">Obras publicadas</h2>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              {author.books.map((b) => (
                <Link key={b.id} to={`/livro/${b.slug}`} className="book-card block">
                  <div className="book-card-inner">
                    <div className="relative aspect-[2/3] overflow-hidden bg-neutral-200 mb-3">
                      <img src={b.cover_url} alt={b.title} className="book-cover w-full h-full object-cover" />
                      {b.status === "coming_soon" && (
                        <span className="absolute top-2 left-2 bg-[color:var(--marupiara-obsidian)] text-[color:var(--marupiara-gold)] text-[10px] uppercase tracking-wider px-2 py-0.5 border border-[color:var(--marupiara-gold)]/40">Em Breve</span>
                      )}
                    </div>
                    <div className="font-serif text-lg text-[color:var(--marupiara-obsidian)]">{b.title}</div>
                    <div className="text-xs text-[color:var(--marupiara-text-on-light-muted)] mt-0.5">{b.year}</div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      )}
    </div>
  );
}
